
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { ProfileSidebar } from "./ProfileSidebar";
import { useAuth } from "@/components/AuthProvider";

interface ProfileSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProfileSheet({ open, onOpenChange }: ProfileSheetProps) {
  const { user } = useAuth();

  const handleOpenChange = (isOpen: boolean) => {
    // Prevent opening if not authenticated
    if (isOpen && !user) {
      return;
    }
    
    console.log('ProfileSheet: handleOpenChange', isOpen);
    onOpenChange(isOpen);
    
    if (!isOpen) {
      setTimeout(() => {
        console.log('ProfileSheet: Restoring pointer events');
        document.body.style.pointerEvents = 'auto';
      }, 1000); // Match the animation duration
    }
  };

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent 
        side="right" 
        className={cn(
          "w-[400px] p-0",
          "fixed top-1/2 -translate-y-1/2 right-6",
          "max-h-[80vh] overflow-y-auto",
          "bg-background/95 backdrop-blur-lg",
          "rounded-xl border-l shadow-lg",
          "pointer-events-auto",
          "!mr-0" // Remove margin from right side
        )}
      >
        <ProfileSidebar />
      </SheetContent>
    </Sheet>
  );
}
